import * as React from 'react';
import { DATE_FORMAT_EXCEL_SERIAL } from '@ooh/contracts';
import { DATE_FORMAT_CUSTOM_VALUE } from '../components/date-format-field';
import type { SetProfile } from './profile-editor-types';

const DATE_FORMAT_PRESET_PATTERNS: Record<string, string | null> = {
  auto: null,
  'dd-mm-yyyy': 'dd.MM.yyyy',
  'yyyy-mm-dd': 'yyyy-MM-dd',
  'excel-serial': DATE_FORMAT_EXCEL_SERIAL,
};

/** date_range: status column, the two explicit date columns, and the date-format-override control. */
export function useDateRangeEditor(setProfile: SetProfile) {
  const [dateFormatSelection, setDateFormatSelection] = React.useState('auto');
  const [dateFormatCustomValue, setDateFormatCustomValue] = React.useState('');

  function handleStatusColumnChange(next: string) {
    setProfile((p) => ({ ...p, statusColumn: next }));
  }

  function handleDateRangeColumnChange(which: 'startColumn' | 'endColumn', next: string) {
    setProfile((p) => ({
      ...p,
      dateRangeColumns: { startColumn: '', endColumn: '', ...p.dateRangeColumns, [which]: next },
    }));
  }

  function applyDateFormatOverride(pattern: string | null) {
    setProfile((p) => {
      if (!p.dateRangeColumns) return p;
      const { startColumn, endColumn } = p.dateRangeColumns;
      const overrides = { ...(p.dateFormatOverrides ?? {}) };
      if (pattern) {
        overrides[startColumn] = pattern;
        overrides[endColumn] = pattern;
      } else {
        delete overrides[startColumn];
        delete overrides[endColumn];
      }
      return { ...p, dateFormatOverrides: overrides };
    });
  }

  function handleDateFormatChange(next: string) {
    setDateFormatSelection(next);
    if (next === DATE_FORMAT_CUSTOM_VALUE) return;
    applyDateFormatOverride(DATE_FORMAT_PRESET_PATTERNS[next] ?? null);
  }

  function handleDateFormatCustomChange(next: string) {
    setDateFormatCustomValue(next);
    applyDateFormatOverride(next || null);
  }

  return {
    dateFormatSelection,
    dateFormatCustomValue,
    handleStatusColumnChange,
    handleDateRangeColumnChange,
    handleDateFormatChange,
    handleDateFormatCustomChange,
  };
}
